import { EasyPlanFAQAssests } from './types/easyPlanFAQ.types';
import leftArrow from './assets/left-arrow.svg';
import headerIcon from './assets/headerIcon.svg';

export const EASY_PLAN_FAQ_ASSETS: EasyPlanFAQAssests = {
  LEFT_ARROW: leftArrow,
  HEADER_ICON: headerIcon,
};
